// extracted by mini-css-extract-plugin
export default {"container":"UE-z","header":"VE-z","details":"WE-z","link":"XE-z"};